<template lang="html">
    <form @submit.prevent="onSubmit()" autocomplete="off" class="form" :class="{ 'loading': isSending }">
        <div class="form__items">
            <div class="form-item">
                <label class="form-item__label">Номер счета</label>
                <div class="default-input">
                    <input
                        v-model="formData.orderId"
                        type="text"
                        inputmode="numeric"
                        name="order-id"
                        :disabled="isDisabled"
                    >
                </div>
            </div>
            <div class="form-item">
                <label class="form-item__label">Сумма по счету</label>
                <div class="default-input">
                    <input
                        v-model="formData.price"
                        type="text"
                        inputmode="numeric"
                        name="price"
                        :disabled="isDisabled"
                    >
                </div>
            </div>
        </div>
        <div class="form__bottom" style="justify-content: flex-start;">
            <button type="submit" class="btn">
                Оплатить
            </button>
            <button v-if="isDisabled" type="button" class="btn btn--white btn--reset" @click="onReset()">
                Очистить поля
            </button>
        </div>
    </form>
</template>

<script>
import {onMounted, reactive, ref} from 'vue';
import {requestSendPaymentSberWidget} from "@/api";

export default {
    name : 'SberWidgetForm',
    setup () {
        const formData = reactive({
            orderId: '',
            price: '',
        })
        const container = document.getElementById("sber-widget");
        const widgetId = "kvk";
        const isSending = ref(false);
        const isDisabled = ref(false);

        onMounted(() => {
            const newDiv = document.createElement('div');
            container.appendChild(newDiv);
        })

        async function onSubmit() {
            isSending.value = true;
            isDisabled.value = true;
            try {
                const response = await requestSendPaymentSberWidget(formData);
                if (response.message) alert(response.message);
                const data = response.data;
                data.orderData.extDataID = crypto.randomUUID()
                if (data) {
                    window.SberWidgetsSDK.create({
                        widgetId,
                        key: data.key,
                        partnerId: data.partnerId,
                        container: container.firstChild,
                        orderData: data.orderData,
                    });
                }
            } catch (error) {
                console.error(error);
                isDisabled.value = false;
            } finally {
                isSending.value = false;
            }
        }
        function onReset() {
            formData.orderId = '';
            formData.price = '';
            isDisabled.value = false;
            container.firstChild.remove()
            const newDiv = document.createElement('div');
            container.appendChild(newDiv);
        }
        return {
            onSubmit,
            onReset,

            formData,
            isSending,
            isDisabled,
        };
    }
}
</script>
